import React from "react";
import style from "./style.module.scss";

type ContainerType = {
  children: React.ReactNode;
  className?: string;
};

export const Container = ({ children, className }: ContainerType) => {
  return <div className={`${style.container} ${className}`}>{children}</div>;
};
